const DELAY = 10000, // 10s
Slider = require('../common/slider')

module.exports = function () {
  const $el = $('#bloc-press'),
    $sources = $el.find('.sources'),
    $inputs = $sources.find('input'),
    $quotes = $el.find('.quotes li')

  function show_next () {
    const index = $inputs.filter(':checked').val()
    $inputs.eq((Number.parseInt(index) + 1) % $inputs.length).click()
  }

  function show_press_quote (index) {
    $sources.attr('data-source-index', index)
    $quotes.removeClass('show')
    $quotes.eq(index).addClass('show')
  }

  let interval = setInterval(show_next, DELAY)

  $el.find('.content').on('mouseenter', function() {
    clearInterval(interval)
  })

  $el.find('.content').on('mouseleave', function() {
    interval = setInterval(show_next, DELAY)
  })

  Slider($el, show_press_quote)
}
